          <picture><img [src]='img' 
               [ngClass]="{'no-blur': !teamMemberBlock_item.name}"
               class="" alt="{{teamMemberBlock_item.alt}}"/></picture>
          
          <div class="caption-img position-absolute top-50 start-50 translate-middle">
               <!-- <a [routerLink]="['/equipo',teamMemberBlock_item.id]"> -->
                    <a (click)="gotoMember(teamMemberBlock_item.id)">
                    <h5 class="fw-bold" [innerHTML]="teamMemberBlock_item.name"></h5>
                    <p [innerHTML]="teamMemberBlock_item.position"></p>
               </a>
               <div class="equipo-blq-social"
               *ngIf="teamMemberBlock_item.linkedinUrl"
               >
                    <a href="{{teamMemberBlock_item.linkedinUrl}}" target="_blank" rel="noreferrer noopener"><img class="rrss-equipo" src="assets/img/linkedin-icon-bl.svg" alt="RRSS. Linkedin"></a>
                    
               </div>
               
          </div>

     
